export function getJsonHeaders(csrfToken) {
  return {
    'Content-Type': 'application/json',
    'X-CSRFToken': csrfToken,
  };
}

export async function postCaseComment({ url, body, csrfToken }) {
  const response = await fetch(url, {
    method: 'POST',
    headers: getJsonHeaders(csrfToken),
    body: JSON.stringify({ body }),
  });

  if (!response.ok) {
    throw new Error('Failed to submit comment');
  }

  return response.json();
}

function getFileMetadata(file) {
  return {
    fileName: file?.name || '',
    fileSizeBytes: Number(file?.size) || 0,
    fileType: file?.type || '',
  };
}

function buildAttachmentUploadError({
  message,
  url,
  file,
  fileIndex,
  totalFiles,
  response,
  responseBodySnippet,
  cause,
}) {
  const error = new Error(message);
  error.name = 'CaseAttachmentUploadError';
  error.uploadContext = {
    uploadUrl: url,
    fileIndex,
    totalFiles,
    ...getFileMetadata(file),
    responseStatus: response?.status || null,
    responseStatusText: response?.statusText || '',
    responseBodySnippet: responseBodySnippet || '',
  };
  if (cause) {
    error.cause = cause;
  }
  return error;
}

export async function uploadCaseAttachments({ url, files, csrfToken }) {
  let latestResponseData = null;

  for (let fileIndex = 0; fileIndex < files.length; fileIndex += 1) {
    const file = files[fileIndex];
    const formData = new FormData();
    formData.append('file', file);

    let response;
    try {
      response = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRFToken': csrfToken,
        },
        body: formData,
      });
    } catch (error) {
      throw buildAttachmentUploadError({
        message: 'Attachment upload request failed before receiving a response',
        url,
        file,
        fileIndex: fileIndex + 1,
        totalFiles: files.length,
        cause: error,
      });
    }

    if (!response.ok) {
      const responseText = await response.text();
      throw buildAttachmentUploadError({
        message: 'Attachment upload API request failed',
        url,
        file,
        fileIndex: fileIndex + 1,
        totalFiles: files.length,
        response,
        responseBodySnippet: String(responseText || '').slice(0, 500),
      });
    }

    try {
      latestResponseData = await response.json();
    } catch (error) {
      throw buildAttachmentUploadError({
        message: 'Attachment upload API returned non-JSON response',
        url,
        file,
        fileIndex: fileIndex + 1,
        totalFiles: files.length,
        response,
        cause: error,
      });
    }
  }

  return latestResponseData;
}
